import ping from './ping';
import offer from './offer';

export { offer, ping };
export default { offer, ping };
